import React, { useState, setState, useEffect, useContext } from 'react';
import { forwardRef, useRef, useImperativeHandle } from 'react';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import { UserContext } from '../../contexts/UserContext';
import Checkbox from '@material-ui/core/Checkbox';

import KeyboardEventHandler from 'react-keyboard-event-handler';
import LoadingOverlay from 'react-loading-overlay';
/*Game Components*/
import GamesList from './gameComponents/GameList';
import GameInfo from './gameComponents/GameInfo';
import GameTabs from './gameComponents/GameTabs';
import './Game.css';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

const Game = forwardRef((props) => {
  const user = useContext(UserContext);
  const [Game, setGame] = React.useState(0);
  const [selectedGameStat, setSelectedGameStat] = React.useState('O');

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      useState,
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: 200,
      },
      '& .MuiFormGroup-row': {
        justifyContent: 'center',
      },
      '& .MuiFormControl-root': {
        justifyContent: 'center',
      },
    },
  }));
  const classes = useStyles();
  let history = useHistory();

  useEffect(() => {
    //Change for server api address
    const url =
      process.env.REACT_APP_API_URL +
      '/GAME?filter=IdGame,eq,' +
      props.match.params.id;
    const timeout = setTimeout(() => {
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setGame(data.records[0]);

          console.log('data props', data);
        }, 500);

      return () => clearTimeout(timeout);
    });
  }, []);
  //subscribeToTimer((err, timestamp) => settimestamp(timestamp));

  function UpdateGame(row) {
    let GameRequest = {
      IdGame: row.IdGame,
      GameName: row.GameName,
      Notes: row.Notes,
      AlternateGame: row.AlternateGame,
      AlternateEnable: row.AlternateEnable,
      PromotionPoints: row.PromotionPoints,
      SL_IfBets: row.SL_IfBets,
      SL_AlwaysActionMLBTotals: row.SL_AlwaysActionMLBTotals,
      PL_MaxGames: row.PL_MaxGames,
      PL_AllowProps: row.PL_AllowProps,
      PL_AllowGolf: row.PL_AllowGolf,
      PL_AllowMatchUps: row.PL_AllowMatchUps,
      PL_NoListedPitchers: row.PL_NoListedPitchers,
      PL_Juice2TeamParlay: row.PL_Juice2TeamParlay,
      PL_TrueOddsOption: row.PL_TrueOddsOption,
      PL_MaxOdds: row.PL_MaxOdds,
      PL_MaxPayout: row.PL_MaxPayout,
      PL_MaxTeamBuyPoints: row.PL_MaxTeamBuyPoints,
      PL_MaxBuyPoints: row.PL_MaxBuyPoints,
      PL_AlwaysAction: row.PL_AlwaysAction,
      PL_AllowRunLineTotal: row.PL_AllowRunLineTotal,
      PL_AllowSpreadTotalHK: row.PL_AllowSpreadTotalHK,
      PL_AllowSpreadTotalSOC: row.PL_AllowSpreadTotalSOC,
      PL_TieLoses: row.PL_TieLoses,
      PL_ParlayFormula: row.PL_ParlayFormula,
      PL_AllowOpenPlays: row.PL_AllowOpenPlays,
      PL_OddsDefault: row.PL_OddsDefault,
      PL_LowerUseDefault: row.PL_LowerUseDefault,
      PL_MaxDogsSide: row.PL_MaxDogsSide,
      PL_MaxDogsTotal: row.PL_MaxDogsTotal,
      PL_MaxDogsMoney: row.PL_MaxDogsMoney,
      PL_UseMaxSumOdds: row.PL_UseMaxSumOdds,
      PL_MaxSumOdds: row.PL_MaxSumOdds,
      IL_MaxParlays: row.IL_MaxParlays,
      IL_MaxLevelParlays: row.IL_MaxLevelParlays,
      IL_MaxTeasers: row.IL_MaxTeasers,
      IL_MaxLevelTeasers: row.IL_MaxLevelTeasers,
      IL_MaxNumberSB: row.IL_MaxNumberSB,
      IL_AskAmount: row.IL_AskAmount,
      IL_AllowChildHigher: row.IL_AllowChildHigher,
      ILOddslimit: row.ILOddslimit,
      PC_PitcherChangeType: row.PC_PitcherChangeType,
      TL_OpenLose: row.TL_OpenLose,
      TL_TeaserCancel: row.TL_TeaserCancel,
      SG_CancelSide: row.SG_CancelSide,
      SG_CancelTotal: row.SG_CancelTotal,
      SG_CancelRunLine: row.SG_CancelRunLine,
      PC_SkipSide: row.PC_SkipSide,
      PC_SkipTotal: row.PC_SkipTotal,
      PC_SkipRunLine: row.PC_SkipRunLine,
      Soc_Hookups: row.Soc_Hookups,
      Rev_AllowOpen: row.Rev_AllowOpen,
      DuplicateBetsCheckLineChange: row.DuplicateBetsCheckLineChange,
      DuplicateBetsCheckParlays: row.DuplicateBetsCheckParlays,
      DuplicateBetsCheckTeasers: row.DuplicateBetsCheckTeasers,
      DuplicateBetsCheckReverses: row.DuplicateBetsCheckReverses,
      DuplicateBetsCheckIfbets: row.DuplicateBetsCheckIfbets,
      DuplicateBetsCheckIfSBRev: row.DuplicateBetsCheckIfSBRev,
      DuplicateBetsCheckParlaysSB: row.DuplicateBetsCheckParlaysSB,
      DuplicateBetsCheckTeasersSB: row.DuplicateBetsCheckTeasersSB,
      DuplicateBetsCheckSameParlay: row.DuplicateBetsCheckSameParlay,
      DuplicateBetsCheckSameTeaser: row.DuplicateBetsCheckSameTeaser,
      FPAllowBothSides: row.FPAllowBothSides,
      FPAllowDuplicatedBets: row.FPAllowDuplicatedBets,
      FPCheckOfficeFilters: row.FPCheckOfficeFilters,
      FPMaxFav: row.FPMaxFav,
      FPMaxPayout: row.FPMaxPayout,
      FPMaxTeams: row.FPMaxTeams,
      FPOddsLimit: row.FPOddsLimit,
      CLMaxWager: row.CLMaxWager,
    };
    axios({
      method: 'post',
      url: process.env.REACT_APP_API2_URL + '/Game/PlayerGame_Update',
      //url: 'https://localhost:44337/api/Game/PlayerGame_Update',
      data: GameRequest,
    }).then((response) => {
      if (response.data === '-1') {
        alert('Data Successfully Updated');
      }
      console.log('response', response);
    });
  }

  const setCurrentGame = (Game) => {
    console.log('in Game props', props);
    console.log('in Game props', Game);
    setGame(Game);
    let anothervar = Game.IdGame.toString();
    //let anothervar = 'Game.IdGame';
    history.push(anothervar);
    console.log('in Game props after anothervar', anothervar);
  };
  return (
    <React.Fragment>
      {console.log('in Game props', props)}

      {Game && (
        <div>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="Game-list" id="GamesCell">
                  <div className="Games-left-div">
                    <GamesList
                      showLoading={props.showLoading}
                      setGame={setCurrentGame}
                    ></GamesList>
                  </div>
                </TableCell>
                <TableCell className="Games-right-div">
                  <div className="Games-right-div">
                    <Paper className={classes.root}>
                      <div
                        id="inputs"
                        style={{ display: 'flex', maxHeight: 45 }}
                      >
                        {true ? (
                          <GameInfo
                            Game={Game}
                            UpdateGame={UpdateGame}
                          ></GameInfo>
                        ) : (
                          <GameInfo
                            Game={Game}
                            UpdateGame={UpdateGame}
                          ></GameInfo>
                        )}
                      </div>

                      <GameTabs
                        AgentInfo={props.location}
                        Game={Game}
                        UpdateGame={UpdateGame}
                        showLoading={props.showLoading}
                      ></GameTabs>
                    </Paper>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      )}
    </React.Fragment>
  );
});

export default Game;
